<template>
    <div class="main">
        <HeaderComponent
            style="margin-top:100px;"
            :text="$t('text.edit_booking')"
            backgroundColor="#fff"
        />
        <Transition appear name="fade">        
            
        </Transition>
            
        <Transition appear name="fade">
            <div class="body-container">
                
                <div v-if="loading" class="loader-container" style="text-align: center; margin-top:80px;">
                    <b-spinner
                        variant="dark"
                        label="Spinning"
                        class="login-loader"
                    ></b-spinner>
                </div>

                <b-form @submit="onSubmit" v-if="!loading && booking != null">
                    <b-form-group id="input-group-0" :label="$t('text.user')" label-for="input-5">
                        <b-form-select
                        id="input-0"
                        v-model="booking.user"
                        :options="users"
                        ></b-form-select>
                        <div style="text-align: right; margin-top:6px; color:#007bff">
                            <a v-if="booking.user != null" @click="goToUser()">Gå till användare</a>
                        </div>
                        
                    </b-form-group>

                     <b-form-group v-if="booking.user==null" id="input-group-1" :label="$t('text.first_name')" label-for="input-1">
                        <b-form-input
                        id="input-1"
                        v-model="booking.first_name"
                        :placeholder="$t('text.enter_first_name')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group v-if="booking.user==null" id="input-group-2" :label="$t('text.last_name')" label-for="input-2">
                        <b-form-input
                        id="input-2"
                        v-model="booking.last_name"
                        :placeholder="$t('text.enter_last_name')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group v-if="booking.user==null" id="input-group-3" :label="$t('text.email_address')" label-for="input-3">
                        <b-form-input
                        id="input-3"
                        v-model="booking.email"
                        type="email"
                        :placeholder="$t('text.enter_email')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group v-if="booking.user==null" id="input-group-4" :label="$t('text.phone')" label-for="input-4">
                        <b-form-input
                        id="input-4"
                        v-model="booking.phone"
                        type="number"
                        :placeholder="$t('text.enter_phone')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-7" :label="$t('text.cabin')" label-for="input-5">
                        <b-form-select
                        id="input-7"
                        v-model="booking.cabin"
                        :options="cabins"
                        required
                        ></b-form-select>
                    </b-form-group>

                    <b-form-group id="input-group-8" :label="$t('text.price')" label-for="input-8">
                        <b-form-input
                        id="input-8"
                        v-model="booking.price"
                        type="number"
                        :placeholder="$t('text.enter_price')"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-4" v-slot="{ ariaDescribedby }">
                        <b-form-checkbox-group
                            v-model="checked"
                            id="checkboxes-4"
                            :aria-describedby="ariaDescribedby"
                            >
                            <b-form-checkbox value="payed">{{ $t('text.payed') }}</b-form-checkbox>
                            <b-form-checkbox value="replied">{{ $t('text.contacted') }}</b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-form-group>

                    <b-form-group v-if="this.booking.cabin!=null" id="input-group-8" :label="$t('text.dates')" label-for="input-8">
                        <HotelDatePicker
                            alwaysVisible
                            showWeekNumbers
                            :firstDayOfWeek="1"
                            :showYear="true"
                            :i18n="localeStrings"
                            :disabledDates="disabledDates"  
                            :startingDateValue="booking.start_date"
                            :endingDateValue="booking.end_date"
                            :startDate="new Date('2018-01-01')"
                            :hoveringTooltip="false"
                            @check-in-changed="setStartDate($event)"
                            @check-out-changed="setEndDate($event)"
                        />
                    </b-form-group>

                    <b-form-group id="input-group-10" label-for="input-10">
                        <b-form-checkbox
                        id="checkbox-10"
                        v-model="booking.has_plus_one"
                        >
                            {{$t('text.friends_included_admin')}}
                        </b-form-checkbox>
                    </b-form-group>
                    
                    <b-form-group id="input-group-6" :label="$t('text.memory_note')" label-for="input-6">
                        <b-form-textarea
                        id="input-4"
                        v-model="booking.notes"
                        type="text"
                        :placeholder="$t('text.message')"
                        ></b-form-textarea>
                    </b-form-group>

                    <p class="error-label" v-if="show_price_warning_text">
                        {{ $t('text.price_has_changed_warning') }}
                    </p>

                    <b-button class="submit-button float-left margin-right" :disabled="!enableSubmitButton" type="submit" variant="primary">{{ $t('text.save') }}</b-button>
                    <b-button class="submit-button float-right" @click="deleteBooking()" variant="danger">{{ $t('text.delete') }}</b-button>

                    <div class="submit-button float-left">
                        <b-dropdown id="dropdown-1" :text="$t('text.more')" variant="dark">
                            <b-dropdown-item @click="goToBookingConfirmation()">{{ $t('text.show_confirmation') }}</b-dropdown-item>
                            <b-dropdown-item @click="resendConfirmationEmail()">{{ $t('text.send_confirmation_email') }}</b-dropdown-item>
                            <b-dropdown-item @click="resendKeyEmail()">{{ $t('text.send_key_email') }}</b-dropdown-item>
                            <b-dropdown-item @click="sendPaymentReminderEmail()">{{ $t('text.send_payment_reminder_email') }}</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </b-form>
            </div>
        </Transition>
    </div>
</template>

<script>
import HotelDatePicker from "vue-hotel-datepicker2";
import "vue-hotel-datepicker2/dist/vueHotelDatepicker2.css";

import HeaderComponent from "../components/HeaderComponent.vue";
import BookingApiService from "../../services/booking_api_service";
import UserApiService from "../../services/user_api_service";
import Booking from "../../models/booking";

export default {
    name: "BookingEditPage",
    components: {
        HeaderComponent,
        HotelDatePicker
    },
    data() {
        return {
            loading: true,
            booking: null,
            users: [{ text: this.$t('text.select_user'), value: null }],
            cabins: [
                { text: this.$t('text.family_cabin'), value: 0 },
                { text: this.$t('text.large_cabin'), value: 1 },
                { text: this.$t('text.small_cabin'), value: 2 }
            ],
            checked: [],
            bookings: [],
            show_price_warning_text: false,
            locale_se: {
                "night": "Natt",
                "nights": "Nätter",
                "week": "vecka",
                "weeks": "veckor",
                "day-names": ["Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön"],
                "check-in": "Check-in",
                "check-out": "Check-out",
                "month-names": [
                    "Januari",
                    "Februari",
                    "Mars",
                    "April",
                    "Maj",
                    "Juni",
                    "Juli",
                    "Augusti",
                    "September",
                    "Oktober",
                    "November",
                    "December",
                ],
                "tooltip": {
                    "halfDayCheckIn": "Tillgänglig CheckIn",
                    "halfDayCheckOut": "Tillgänglig CheckOut",
                    "saturdayToSaturday": "Endast Lördag till Söndag",
                    "sundayToSunday": "Endast Söndag till Söndag",
                    "minimumRequiredPeriod": "%{minNightInPeriod} %{night} minimum.",
                },
            },
            locale_en: {
                "night": "Night",
                "nights": "Nights",
                "week": "week",
                "weeks": "weeks",
                "day-names": ["Mon", "Tue", "Wed", "Thur", "Fri", "Sat", "Sun"],
                "check-in": "Check-in",
                "check-out": "Check-out",
                "month-names": [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                ],
                "tooltip": {
                    "halfDayCheckIn": "Available CheckIn",
                    "halfDayCheckOut": "Available CheckOut",
                    "saturdayToSaturday": "Only Saturday to Saturday",
                    "sundayToSunday": "Only Sunday to Sunday",
                    "minimumRequiredPeriod": "%{minNightInPeriod} %{night} minimum.",
                },
            },
        };
    },
    watch: {
        checked: function(newValue) {
            this.booking.payed = newValue.includes('payed')
            this.booking.replied = newValue.includes('replied')
        },
        'booking.cabin': {
            handler: function (_, oldValue) {
                if (oldValue == null) { return }
                this.booking.start_date = null;
                this.booking.end_date = null;
            },
            deep: true
        },
        'booking.user': {
            handler: function (_, oldValue) {
                if (oldValue == null) { return }
                if (this.booking.start_date != null && this.booking.end_date != null) {
                    this.fetchBookingPrice()
                }
            },
            deep: true
        },
        'booking.has_plus_one': {
            handler: function (_, oldValue) {
                if (oldValue == null) { return }
                if (this.booking.start_date != null && this.booking.end_date != null) {
                    this.fetchBookingPrice()
                }
            },
            deep: true
        },
        
    },
    computed: {
        disabledDates() {
            var dates = []
            const existing_bookings = this.bookings.filter((existing_booking) => {return (existing_booking.cabin == this.booking.cabin && existing_booking.id != this.booking.id) })
            for (var i in existing_bookings) {
                dates = dates.concat(this.getDaysArray(existing_bookings[i].start_date, existing_bookings[i].end_date))
            }
            return dates;
            //return [];
        },
        localeStrings() {
            return (this.$root.$i18n.locale == "en" ? this.locale_en : this.locale_se);
        },
        enableSubmitButton() {
            if (this.booking == null) { return false }
            return (
                this.correctDatesSelected &&
                (
                    this.booking.user != null ||
                    (
                        this.booking.first_name != '' &&
                        this.booking.last_name != '' &&
                        this.booking.email != '' &&
                        this.booking.phone != ''
                    )
                )
            );
        },
        correctDatesSelected() {
            return this.booking.start_date != null && this.booking.end_date != null
        },
    },
    methods: {
        async fetchBooking() {
            this.loading = true;
            try {
                const data = await BookingApiService.get_detail(this.$route.params.booking_id);
                this.booking = new Booking(data.data);
                if (this.booking.payed) {
                    this.checked.push('payed')
                }
                if (this.booking.replied) {
                    this.checked.push('replied')
                }
                this.loading = false;
                this.fetchBookings();
                this.fetchUsers();
            } catch (error) {
                this.loading = false;
                if (this.$store.getters.token_valid && this.$store.getters.isLoggedIn) {
                    this.$router.push("/404");
                }
            }
        },
        async deleteBooking() {
            this.$bvModal.msgBoxConfirm(
                this.$t('text.are_you_sure_delete_booking'), 
                {
                    okTitle: this.$t('text.delete_booking'),
                    cancelTitle: this.$t('text.cancel'),
                    okVariant: 'danger',
                }
            )
            .then(async value => {
                if (value) {
                    this.loading = true;
                    try {
                        await BookingApiService.delete(this.booking.id);
                        this.loading = false;
                        this.$router.push("/admin/bookings")
                    } catch (error) {
                        this.loading = false;
                    }
                }
            })
        },
        async fetchBookingPrice() {
            try {
                const data = await BookingApiService.get_price_for_dates(
                    this.booking.user,
                    this.booking.cabin,
                    this.booking.start_date.toISOString().split('T')[0],
                    this.booking.end_date.toISOString().split('T')[0],
                    this.booking.has_plus_one,
                );
                if (data.data.price != this.booking.price) {
                    this.show_price_warning_text = true;
                }
                this.booking.price = data.data.price
            } catch (error) {
                localStorage.clear();
            }
        },
        async resendConfirmationEmail() {
            this.$bvModal.msgBoxConfirm(
                this.$t('text.are_you_sure_resend_confirmation_email'), 
                {
                    okTitle: this.$t('text.send'),
                    cancelTitle: this.$t('text.cancel'),
                    okVariant: 'warning',
                }
            )
            .then(async value => {
                if (value) {
                    this.loading = true;
                    try {
                        await BookingApiService.resend_confirmation_email(this.booking.id);
                        this.loading = false;
                        this.$bvModal.msgBoxOk(this.$t('text.confirmation_email_sent'))
                        this.booking.replied = true;
                        this.checked.push('replied')
                    } catch (error) {
                        this.$bvModal.msgBoxOk(this.$t('text.confirmation_email_fail'), {
                            okVariant: 'danger'
                        })
                        this.loading = false;
                    }
                }
            })
        },
        
        async resendKeyEmail() {
            this.$bvModal.msgBoxConfirm(
                this.$t('text.are_you_sure_resend_key_email'), 
                {
                    okTitle: this.$t('text.send'),
                    cancelTitle: this.$t('text.cancel'),
                    okVariant: 'warning',
                }
            )
            .then(async value => {
                if (value) {
                    this.loading = true;
                    try {
                        await BookingApiService.resend_key_email(this.booking.id);
                        this.loading = false;
                        this.$bvModal.msgBoxOk(this.$t('text.key_email_sent'))
                    } catch (error) {
                        this.$bvModal.msgBoxOk(this.$t('text.key_email_fail'), {
                            okVariant: 'danger'
                        })
                        this.loading = false;
                    }
                }
            })
        },

        async sendPaymentReminderEmail() {
            this.$bvModal.msgBoxConfirm(
                this.$t('text.are_you_sure_send_payment_reminder_email'), 
                {
                    okTitle: this.$t('text.send'),
                    cancelTitle: this.$t('text.cancel'),
                    okVariant: 'warning',
                }
            )
            .then(async value => {
                if (value) {
                    this.loading = true;
                    try {
                        await BookingApiService.send_payment_reminder_email(this.booking.id);
                        this.loading = false;
                        this.$bvModal.msgBoxOk(this.$t('text.payment_reminder_email_sent'))
                    } catch (error) {
                        this.$bvModal.msgBoxOk(this.$t('text.payment_reminder_email_fail'), {
                            okVariant: 'danger'
                        })
                        this.loading = false;
                    }
                }
            })
        },

        async updateBooking() {
            this.$bvModal.msgBoxConfirm(
                this.$t('text.are_you_sure_update_booking'), 
                {
                    okTitle: this.$t('text.save'),
                    cancelTitle: this.$t('text.cancel'),
                }
            )
            .then(async value => {
                if (value) {
                    this.loading = true;
                    var payload = this.booking.toDict()
                    try {
                        await BookingApiService.patch(this.booking.id, payload);
                        this.loading = false;
                        this.$router.push("/admin/bookings/")
                    } catch (error) {
                        var errorString = this.$t("text.something_went_wrong_try_later")
                        if (error.response.status === 400) {
                            errorString = ""
                            for (var key in error.response.data) {
                                errorString += error.response.data[key][0]
                                errorString += " "
                            }
                        }
                        this.$bvModal.msgBoxOk(errorString, {okVariant: 'danger'})
                        this.loading = false;
                    }
                }
            })
        },
        async fetchUsers() {
            this.loading = true;
            const params = "order_by=first_name"
            try {
                const data = await UserApiService.get_all(params);
                this.users = this.users.concat(data.data.map(dict => {
                    return {
                        text: dict.first_name + ' ' + dict.last_name + ' - ' + dict.email + ' - ' + dict.phone,
                        value: dict.id
                    }
                }));
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        async fetchBookings() {
            this.loading = true;
            try {
                const data = await BookingApiService.get_for_calendar();
                this.bookings = data.data.map(dict => {
                    return new Booking(dict);
                });
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        getDaysArray(start, end) {
            for(var arr=[],dt=new Date(start); dt<=new Date(end); dt.setDate(dt.getDate()+1)){
                arr.push(new Date(dt).toISOString().split('T')[0]);
            }
            return arr;
        },
        setStartDate(date) {
            if (date != null) {
                date.setHours(12,0,0,0);
            }
            this.booking.start_date = date;
        },
        setEndDate(date) {
            if (date != null) {
                date.setHours(12,0,0,0);
            }
            this.booking.end_date = date;
            if (this.booking.start_date != null && this.booking.end_date != null) {
                this.fetchBookingPrice()
            }
        },
        onSubmit(event) {
            event.preventDefault()
            this.updateBooking()
        },
        makeToast(variant = null, title, body) {
            this.$bvToast.toast(body, {
                title: title,
                toaster: "b-toaster-top-center",
                variant: variant,
                solid: true
            });
        },
        goToUser() {
            if (this.booking.user) {
                this.$router.push("/user/" + this.booking.user)
            }
        },
        goToBookingConfirmation() {
            this.$router.push({path: "/booking-confirmation", query: { uuid: this.booking.uuid }})
        },
    },
    created() {
        this.fetchBooking();
    },
    mounted() {
        if (!(this.$store.getters.token_valid && this.$store.getters.isLoggedIn)) {
            this.$router.push({ name: 'login', query: { redirect: this.$router.currentRoute } });
        }
    }

};
</script>

<style scoped>
.main {
  height: 100%;
  background-color: #fff;
}

.body-container {
    text-align: left;
    margin: auto;

    padding-bottom: 100px;
    padding-left: 30px;
    padding-right: 30px;

    max-width: 860px;
}

.submit-button {
    margin-bottom: 8px;
}

.float-left {
    float:left;
}
.float-right {
    float:right;
}

.margin-right {
    margin-right: 10px;
}

.error-label {
    color: #dc3545;
    font-size:14px;
    text-align:center;
}

</style>
